"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isModel = exports.isTagged = exports.tagPromise = exports.isArray = exports.isAsync = exports.isPlainObject = exports.getType = void 0;

require("core-js/modules/es.object.to-string.js");

var _constants = require("./constants");

var getType = function getType(arg) {
  return Object.prototype.toString.call(arg);
};

exports.getType = getType;

var isPlainObject = function isPlainObject(target) {
  return getType(target) === '[object Object]';
};

exports.isPlainObject = isPlainObject;

var isAsync = function isAsync(target) {
  return getType(target) === '[object AsyncFunction]' || getType(target) === '[object Promise]';
};

exports.isAsync = isAsync;

var isArray = function isArray(target) {
  return getType(target) === '[object Array]';
};

exports.isArray = isArray;

var tagPromise = function tagPromise(p) {
  Object.defineProperty(p, _constants.promiseTouchedByModel, {
    value: true,
    writable: false,
    configurable: false,
    enumerable: false
  });
};

exports.tagPromise = tagPromise;

var isTagged = function isTagged(p) {
  return p[_constants.promiseTouchedByModel];
};

exports.isTagged = isTagged;

var isModel = function isModel(model) {
  if (!model) return false;
  return model[_constants.gluerUniqueFlagKey] === _constants.gluerUniqueFlagValue;
};

exports.isModel = isModel;